/**
 * Feature Flags System for Matcha
 * Controls beta features and experimental functionality
 */

// Feature flag configuration
const FEATURE_FLAGS = {
  // Story Mode Beta - Controls access to Story Mode
  storyModeBeta: {
    enabled: process.env.REACT_APP_STORY_MODE_BETA === 'true',
    description: 'Story Mode with progressive levels'
  }
};

/**
 * Check if a feature is enabled
 * @param {string} featureName - Name of the feature flag
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (featureName) => {
  const feature = FEATURE_FLAGS[featureName];
  if (!feature) {
    console.warn(`Unknown feature flag: ${featureName}`);
    return false;
  }
  return feature.enabled;
};

/**
 * Get all enabled features
 * @returns {Object} - Object with feature names as keys and enabled status as values
 */
export const getEnabledFeatures = () => {
  const enabled = {};
  Object.keys(FEATURE_FLAGS).forEach(key => {
    enabled[key] = FEATURE_FLAGS[key].enabled;
  });
  return enabled;
};

const featureFlags = {
  isFeatureEnabled,
  getEnabledFeatures
};

export default featureFlags;
